import { Col, message, Row } from 'antd';
import axios from 'axios';
import { t } from 'i18next';
import _ from 'lodash';
import moment from 'moment';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import PrimaryButton from '../../../../component/button/PrimaryButton';
import SecondaryButton from '../../../../component/button/SecondaryButton';
import ModalConfirmLeave from '../../../../component/modal/ModalConfirmLeave';
import ModalSuccessCompletion from '../../../../component/modal/ModalSuccessCompletion';
import { GROLOG_URL } from '../../../../constant/apiConstant';
import { ROUTES } from '../../../../constant/routeConstant';
import CompanyProfileCompletion from './CompanyProfileCompletion';
import UserProfileCompletion from './UserProfileCompletion';
import { validCompletion } from './validation';

const CompletionData = () => {
  const {grologAccInfo} = useSelector((state)=>state.auth)
  const [tab, setTab] = useState(1);
  const [form,setForm]= useState([])
  const [error,setError]=useState()
  const [modal, setModal] = useState(false)
  const [showConfirm, setShowConfirm]=useState(false)
  const [change, setChange] = useState(false)
  const navigate = useNavigate();
  const api = GROLOG_URL;const { token} = useSelector(
    (state) => state.auth
  );
  const handleChange = (value, name) => {
    setChange(true)
      if(name==="birth_date"){
        let eror = validCompletion(name, value, t);
      setError({ ...error, ...eror });
      
        setForm((prevsValue) => {
          return {
            ...prevsValue,
            [name]: moment(new Date(value)).format("YYYY-MM-DD"),
          };
        });
      }else if (name === "company_title") {
        let eror = validCompletion(name, value, t);
      setError({ ...error, ...eror });
        setForm((prevsValue) => {
          return {
            ...prevsValue,
            [name]: value,
          };
        });
      }else{
        
        let eror = validCompletion(name, value.target.value, t);
      setError({ ...error, ...eror });
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          [name]: value.target.value,
        };
      });
    }
  }
  const validateSubmit = (error) => {
    for (const key in error) {
      if (Object.hasOwnProperty.call(error, key)) {
        if (error[key]) return false;
      }
    }
    return true;
  };

  const handleNext = () => {
    let errors={}
    var moment = require('moment');
var today = moment().format('YYYY-MM-DD');
    let sub={
      email:form?.email,
      birth_date:form?.birth_date ? form?.birth_date : today
    }
    for (const key in sub) {
      const option = validCompletion(key, sub[key], t);
      const currentError = option;
      errors = { ...currentError, ...errors };
    }
    setError(errors);
    if (validateSubmit(errors)) {
      setTab(2);
    }
  }

  const doPost = async (endpoint, tkn, data, dispatch, refresh_token) => {
    const url = api + endpoint;
    const method = "POST";
    // const headers = { Authorization: tkn };
    const request = { url, method,data };
    return axios(request);
  };

  const handleSubmit = async()=>{
    let errors={}
    var moment = require('moment');
var today = moment().format('YYYY-MM-DD');
    let sub={
      company_title:form?.company_title,
      company_name:form?.company_name,
      company_phone:form?.company_phone,
      company_country:form?.company_country,
      company_province:form?.company_province,
      company_address:form?.company_address,
      email:form?.email,

    }

    for (const key in sub) {
      const option = validCompletion(key, sub[key], t);
      const currentError = option;
      errors = { ...currentError, ...errors };
    }
    setError(errors);
    let datas={
      company_title:form?.company_title,
      company_name:form?.company_name,
      company_phone:"+62-"+form?.company_phone,
      company_country:form?.company_country,
      company_province:form?.company_province,
      company_address:form?.company_address,
      email:form?.email,
      birth_date:form?.birth_date ? form?.birth_date : today,
      client_id: grologAccInfo?.client_id
    }
    if (validateSubmit(errors)) {
      try{
        let res = await doPost(`/completion-user`, token, datas);
        setModal(true);
        // message.success(_.startCase("success completion"));
        // navigate(ROUTES.INDEX)
     
      }catch(err){
   message.error(_.startCase(err.response.data.payload.message));
     
      }
      // setTab(2);
    }
  }

  const handleBack = () => {
    setTab(1);
  }

  const handleOk =()=>{
    setModal(false)
    navigate(ROUTES.INDEX)
  }

  return (
    <>
    <ModalSuccessCompletion
    show={modal}
    action={()=>handleOk()}
    />
      <div className='p-5 m-5 rounded-[10px] bg-[#FFFFFF]'>
        <div className='font-sans-bold text-[28px] text-black-100'>
          {t("LOGIN_COMPLETION:TITLE_PAGE")}
        </div>
        <div className='font-roboto-medium text-[16px] text-[#424242]'>
          {t("LOGIN_COMPLETION:SUB_TITLE_PAGE")}
        </div>

        <div className='w-1/2 mt-5'>
          <Row className='bg-[#F3F3F3] h-[52px] rounded-md'>
            <Col span={12}>
              <Row>
                <Col className='grid place-items-center h-[52px]' span={4}>
                  <div className={`border ${tab === 1 ? 'border-red-100 bg-red-100' : 'border-[#228B22] bg-[#228B22]'} rounded-full w-[36px] h-[36px] grid place-items-center`}>
                    <p className='font-sans text-xl font-semibold text-white-100'>1</p>
                  </div>
                </Col>
                <Col className='flex items-center' span={12}>
                  <p className={`font-sans text-xl font-bold ${tab === 1 ? 'text-red-100' : 'text-[#228B22]' }`}> User Profile </p>
                </Col>
                <Col className='flex items-center' span={8}>
                  <hr className={`border-2 w-full ${tab === 1 ? ' border-[#D7D7D7] border-dashed ' : 'border-[#228B22] border-solid'} `} />
                </Col>
              </Row>
            </Col>
            <Col span={12}>
              <Row>
                <Col className='grid place-items-center h-[52px]' span={4}>
                  <div className={`border rounded-full w-[36px] h-[36px] grid place-items-center ${tab === 1 ? 'bg-[#FFFFFF] border-[#FFFFFF]' : 'border-red-100 bg-red-100' }`}>
                    <p className={`font-sans text-xl font-semibold ${tab === 1 ? 'text-[#ACACAC]' : 'text-white-100'}`}>2</p>
                  </div>
                </Col>
                <Col className='flex items-center' span={20}>
                  <p className={`font-sans text-xl font-bold ${tab === 1 ? 'text-[#ACACAC]' : 'text-red-100'}`}> Company Profile </p>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>

        <div>
          <div className='font-roboto font-semibold text-[20px] mt-5'>
            {t("LOGIN_COMPLETION:TITLE_LAYOUT")}
          </div>
          <div className='font-roboto text-[16px] text-[#424242]'>
            {t("LOGIN_COMPLETION:SUB_TITLE_LAYOUT")}
          </div>
          <div className='font-roboto-medium text-[18px] font-medium mt-3'>
            {t("LOGIN_COMPLETION:PERSONAL_INFORMATION")}
          </div>
          {
            tab === 1 ? (
              <UserProfileCompletion
              handleChange={(value,name)=>handleChange(value, name)}
              form={form} 
              error={error}/>
            ) : (
              <CompanyProfileCompletion
              handleChange={(value,name)=>handleChange(value, name)}
              form={form}
              error={error} />
            )
          }
          <ModalConfirmLeave
        visible={showConfirm}
        action={() => setShowConfirm(false)}
        route={ROUTES.INDEX}
        iscompletion={true}
      />
        </div>
      </div>
      <div className='flex flex-row-reverse gap-[16px] px-5 m-5'>
        {
          tab === 1 ? (
            <>
              <PrimaryButton action={handleNext} text={t("COMMON:NEXT")} />
              <SecondaryButton text={t("USER_DETAIL:CANCEL")}  action={
              change
                ? () => setShowConfirm(true)
                : () => navigate(ROUTES.INDEX)
            } />
            </>
          ) : (
            <>
              <PrimaryButton text={t("USER_DETAIL:SAVE")} action={()=>handleSubmit()}/>
              <SecondaryButton action={handleBack} text={t("Back")} />
            </>
          )
        }
      </div>

    </>
  );
};

export default CompletionData;